import { render, staticRenderFns } from "./role_messenger.vue?vue&type=template&id=6b89d7a8&scoped=true&"
import script from "./role_messenger.vue?vue&type=script&lang=ts&"
export * from "./role_messenger.vue?vue&type=script&lang=ts&"
import style0 from "./role_messenger.vue?vue&type=style&index=0&id=6b89d7a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b89d7a8",
  null
  
)

export default component.exports